import React from 'react'
import { NavLink } from 'react-router-dom'

export const AccountMenu = () => {
	const dashboard = require('../images/dashboard.svg')
	const kyc = require('../images/kyc.svg')
	const deposits = require('../images/deposit.svg')
	const withdrawals = require('../images/withdraw.svg')
	const orderbooks = require('../images/orderbook.svg')
	const users = require('../images/profile.svg')
	const coldWallets = require('../images/vault.svg')
	const hotWallets = require('../images/wallets.svg')
	const custody = require('../images/custody.svg')
	const fees = require('../images/fees.svg')
	const lion = require('../images/lion.svg')
	const services = require('../images/control.svg')

	return (
		<div className='accountMenu'>
			<div className='sideMenu'>
				<NavLink activeClassName='leftMenuSelected' to='/dashboard'><img src={dashboard} className='icon' alt='dashboard' /><span>Dashboard</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/kyc'><img src={kyc} className='icon' alt='kyc' /><span>KYC</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/deposits'><img src={deposits} className='icon' alt='deposits' /><span>Deposits</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/withdrawals'><img src={withdrawals} className='icon' alt='withdrawals' /><span>Withdrawals</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/orderbooks'><img src={orderbooks} className='icon' alt='orderbooks' /><span>Orderbooks</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/users'><img src={users} className='icon' alt='users' /><span>Users</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/custody'><img src={custody} className='icon' alt='custody' /><span>Custody</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/fees'><img src={fees} className='icon' alt='fees' /><span>Fees</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/govBr'><img src={lion} className='icon' alt='govBr' /><span>IN 1888</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/hotWallets'><img src={hotWallets} className='icon' alt='hotWallets' /><span>Hot Wallets</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/coldWallets'><img src={coldWallets} className='icon' alt='coldWallets' /><span>Cold Wallets</span></NavLink>
				<NavLink activeClassName='leftMenuSelected' to='/services'><img src={services} className='icon' alt='services' /><span>Services</span></NavLink>
			</div>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/accountMenu.tsx